/**
 * JWAY ICONS SET
 */

export interface IconProps {
  color?: string;
  size?: number;
}

export type IconType =
  | "home"
  | "coin"
  | "electricStation"
  | "peoples"
  | "building"
  | "profil"
  | "bell"
  | "link-crooked"
  | "copy"
  | "visibility-off"
  | "admin"
  | "visibility"
  | "thunder"
  | "plus-in-cercle"
  | "electric-car-plug"
  | "ship"
  | "search"
  | "trash"
  | "edit-sheet"
  | "check-valid"
  | "prohibited"
  | "cross"
  | "download"
  | "pdf"
  | "excel"
  | "stop-square"
export const HomeIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 13C0.89543 13 0 12.1046 0 11V5.35596C0 4.71375 0.308394 4.1106 0.829019 3.7346L4.82902 0.845709C5.52805 0.340853 6.47195 0.340853 7.17098 0.845709L11.171 3.7346C11.6916 4.1106 12 4.71375 12 5.35596V11C12 12.1046 11.1046 13 10 13H9.5C8.39543 13 7.5 12.1046 7.5 11V9.44444C7.5 8.61602 6.82843 7.94444 6 7.94444V7.94444C5.17157 7.94444 4.5 8.61602 4.5 9.44444V11C4.5 12.1046 3.60457 13 2.5 13H2Z"
      fill={color}
    />
  </svg>
);

export const CheckValidationIcon = ({
  size = 30,
  color = "black",
}: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.54998 13L0.849976 7.29998L2.27498 5.87498L6.54998 10.15L15.725 0.974976L17.15 2.39998L6.54998 13Z"
      fill={color}
    />
  </svg>
);
export const ShipIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 4H4.25C4.11193 4 4 4.11193 4 4.25V9.75C4 9.88807 4.11193 10 4.25 10H9.75C9.88807 10 10 9.88807 10 9.75V4.25C10 4.11193 9.88807 4 9.75 4Z"
      fill={color}
    />
    <path
      d="M13.5 5C13.6326 5 13.7598 4.94732 13.8536 4.85355C13.9473 4.75979 14 4.63261 14 4.5C14 4.36739 13.9473 4.24021 13.8536 4.14645C13.7598 4.05268 13.6326 4 13.5 4H13V3C12.9994 2.46974 12.7885 1.96137 12.4136 1.58643C12.0386 1.21148 11.5303 1.00058 11 1H10V0.5C10 0.367392 9.94732 0.240215 9.85355 0.146447C9.75979 0.0526784 9.63261 0 9.5 0C9.36739 0 9.24021 0.0526784 9.14645 0.146447C9.05268 0.240215 9 0.367392 9 0.5V1H7.5V0.5C7.5 0.367392 7.44732 0.240215 7.35355 0.146447C7.25979 0.0526784 7.13261 0 7 0C6.86739 0 6.74021 0.0526784 6.64645 0.146447C6.55268 0.240215 6.5 0.367392 6.5 0.5V1H5V0.5C5 0.367392 4.94732 0.240215 4.85355 0.146447C4.75979 0.0526784 4.63261 0 4.5 0C4.36739 0 4.24021 0.0526784 4.14645 0.146447C4.05268 0.240215 4 0.367392 4 0.5V1H3C2.46974 1.00058 1.96137 1.21148 1.58643 1.58643C1.21148 1.96137 1.00058 2.46974 1 3V4H0.5C0.367392 4 0.240215 4.05268 0.146447 4.14645C0.0526784 4.24021 0 4.36739 0 4.5C0 4.63261 0.0526784 4.75979 0.146447 4.85355C0.240215 4.94732 0.367392 5 0.5 5H1V6.5H0.5C0.367392 6.5 0.240215 6.55268 0.146447 6.64645C0.0526784 6.74021 0 6.86739 0 7C0 7.13261 0.0526784 7.25979 0.146447 7.35355C0.240215 7.44732 0.367392 7.5 0.5 7.5H1V9H0.5C0.367392 9 0.240215 9.05268 0.146447 9.14645C0.0526784 9.24021 0 9.36739 0 9.5C0 9.63261 0.0526784 9.75979 0.146447 9.85355C0.240215 9.94732 0.367392 10 0.5 10H1V11C1.00058 11.5303 1.21148 12.0386 1.58643 12.4136C1.96137 12.7885 2.46974 12.9994 3 13H4V13.5C4 13.6326 4.05268 13.7598 4.14645 13.8536C4.24021 13.9473 4.36739 14 4.5 14C4.63261 14 4.75979 13.9473 4.85355 13.8536C4.94732 13.7598 5 13.6326 5 13.5V13H6.5V13.5C6.5 13.6326 6.55268 13.7598 6.64645 13.8536C6.74021 13.9473 6.86739 14 7 14C7.13261 14 7.25979 13.9473 7.35355 13.8536C7.44732 13.7598 7.5 13.6326 7.5 13.5V13H9V13.5C9 13.6326 9.05268 13.7598 9.14645 13.8536C9.24021 13.9473 9.36739 14 9.5 14C9.63261 14 9.75979 13.9473 9.85355 13.8536C9.94732 13.7598 10 13.6326 10 13.5V13H11C11.5303 12.9994 12.0386 12.7885 12.4136 12.4136C12.7885 12.0386 12.9994 11.5303 13 11V10H13.5C13.6326 10 13.7598 9.94732 13.8536 9.85355C13.9473 9.75979 14 9.63261 14 9.5C14 9.36739 13.9473 9.24021 13.8536 9.14645C13.7598 9.05268 13.6326 9 13.5 9H13V7.5H13.5C13.6326 7.5 13.7598 7.44732 13.8536 7.35355C13.9473 7.25979 14 7.13261 14 7C14 6.86739 13.9473 6.74021 13.8536 6.64645C13.7598 6.55268 13.6326 6.5 13.5 6.5H13V5H13.5ZM11 10C11 10.2652 10.8946 10.5196 10.7071 10.7071C10.5196 10.8946 10.2652 11 10 11H4C3.73478 11 3.48043 10.8946 3.29289 10.7071C3.10536 10.5196 3 10.2652 3 10V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10C10.2652 3 10.5196 3.10536 10.7071 3.29289C10.8946 3.48043 11 3.73478 11 4V10Z"
      fill={color}
    />
  </svg>
);

export const CrossIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.40298 24.4395L0 23.068L11.097 12.2197L0 1.37153L1.40298 0L12.5 10.8482L23.597 0L25 1.37153L13.903 12.2197L25 23.068L23.597 24.4395L12.5 13.5913L1.40298 24.4395Z"
      fill={color}
    />
  </svg>
);

export const ThunderIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 12 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 14H0L7 0V8H12L5 22V14Z" fill={color} />
  </svg>
);

export const CoinIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16ZM5.2 9.6V11.2H7.2V12.8H8.8V11.2H9.6C10.1304 11.2 10.6391 10.9893 11.0142 10.6142C11.3893 10.2391 11.6 9.73043 11.6 9.2C11.6 8.66957 11.3893 8.16086 11.0142 7.78579C10.6391 7.41071 10.1304 7.2 9.6 7.2H6.4C6.29391 7.2 6.19217 7.15786 6.11716 7.08284C6.04214 7.00783 6 6.90609 6 6.8C6 6.69391 6.04214 6.59217 6.11716 6.51716C6.19217 6.44214 6.29391 6.4 6.4 6.4H10.8V4.8H8.8V3.2H7.2V4.8H6.4C5.86957 4.8 5.36086 5.01071 4.98579 5.38579C4.61071 5.76086 4.4 6.26957 4.4 6.8C4.4 7.33043 4.61071 7.83914 4.98579 8.21421C5.36086 8.58929 5.86957 8.8 6.4 8.8H9.6C9.70609 8.8 9.80783 8.84214 9.88284 8.91716C9.95786 8.99217 10 9.09391 10 9.2C10 9.30609 9.95786 9.40783 9.88284 9.48284C9.80783 9.55786 9.70609 9.6 9.6 9.6H5.2Z"
      fill={color}
    />
  </svg>
);

export const CopyIon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1H1V14"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 5H17V17C17 17.5304 16.7893 18.0391 16.4142 18.4142C16.0391 18.7893 15.5304 19 15 19H7C6.46957 19 5.96086 18.7893 5.58579 18.4142C5.21071 18.0391 5 17.5304 5 17V5Z"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PlusInCercleIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 11H11V15H9V11H5V9H9V5H11V9H15M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
      fill={color}
    />
  </svg>
);

export const StopSquareIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg width={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V10C5 10.2652 5.10536 10.5196 5.29289 10.7071C5.48043 10.8946 5.73478 11 6 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5H6Z" fill={color}/>
</svg>

)

export const LinkCrookedIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8278 12.238L13.533 10.9413L14.8278 9.6465C15.6802 8.78656 16.1573 7.62397 16.1546 6.41313C16.1519 5.20229 15.6698 4.0418 14.8136 3.1856C13.9575 2.32941 12.7971 1.84723 11.5863 1.84458C10.3755 1.84193 9.21297 2.31902 8.35308 3.17146L7.0574 4.4672L5.76264 3.17237L7.0574 1.87755C8.25952 0.675374 9.88993 0 11.59 0C13.29 0 14.9204 0.675374 16.1225 1.87755C17.3247 3.07972 18 4.71022 18 6.41035C18 8.11048 17.3247 9.74098 16.1225 10.9432L14.8278 12.238ZM12.2374 14.8276L10.9426 16.1225C9.74048 17.3246 8.11007 18 6.41002 18C4.70998 18 3.07957 17.3246 1.87745 16.1225C0.67534 14.9203 1.79129e-08 13.2898 0 11.5896C-1.79129e-08 9.88952 0.67534 8.25902 1.87745 7.05685L3.17313 5.76202L4.46789 7.05868L3.17313 8.3535C2.33242 9.21571 1.86524 10.3744 1.87279 11.5787C1.88033 12.7829 2.362 13.9357 3.21344 14.7873C4.06488 15.6389 5.21754 16.1208 6.42172 16.1285C7.6259 16.1362 8.78464 15.6692 9.64692 14.8285L10.9426 13.5337L12.2374 14.8276ZM11.59 5.11461L12.8857 6.41035L6.41002 12.8845L5.11527 11.5896L11.59 5.11461Z"
      fill={color}
    />
  </svg>
);

export const ElectricStationIcon = ({
  size = 30,
  color = "black",
}: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4248 3.33273L12.4327 3.32485L9.50182 0.393939L8.66667 1.22909L10.3291 2.89152C9.58849 3.17515 9.06061 3.88424 9.06061 4.72727C9.06061 4.98594 9.11155 5.24207 9.21054 5.48104C9.30953 5.72002 9.45461 5.93716 9.63752 6.12006C10.0069 6.48945 10.5079 6.69697 11.0303 6.69697C11.3139 6.69697 11.5739 6.63394 11.8182 6.53152V12.2121C11.8182 12.6455 11.4636 13 11.0303 13C10.597 13 10.2424 12.6455 10.2424 12.2121V8.66667C10.2424 7.8 9.53333 7.09091 8.66667 7.09091H7.87879V1.57576C7.87879 0.709091 7.1697 0 6.30303 0H1.57576C0.709091 0 0 0.709091 0 1.57576V14.1818H7.87879V8.27273H9.06061V12.2121C9.06061 12.7345 9.26813 13.2355 9.63752 13.6049C10.0069 13.9743 10.5079 14.1818 11.0303 14.1818C11.5527 14.1818 12.0537 13.9743 12.4231 13.6049C12.7925 13.2355 13 12.7345 13 12.2121V4.72727C13 4.18364 12.7794 3.68727 12.4248 3.33273ZM11.0303 5.51515C10.597 5.51515 10.2424 5.16061 10.2424 4.72727C10.2424 4.29394 10.597 3.93939 11.0303 3.93939C11.4636 3.93939 11.8182 4.29394 11.8182 4.72727C11.8182 5.16061 11.4636 5.51515 11.0303 5.51515ZM3.15152 11.8182V8.27273H1.57576L4.72727 2.36364V6.30303H6.30303L3.15152 11.8182Z"
      fill={color}
    />
  </svg>
);

export const PeoplesIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.7 7.52941C6.70782 7.52941 7.67437 7.13277 8.38701 6.42676C9.09964 5.72074 9.5 4.76317 9.5 3.76471C9.5 2.76624 9.09964 1.80868 8.38701 1.10266C7.67437 0.396637 6.70782 0 5.7 0C4.69218 0 3.72563 0.396637 3.01299 1.10266C2.30036 1.80868 1.9 2.76624 1.9 3.76471C1.9 4.76317 2.30036 5.72074 3.01299 6.42676C3.72563 7.13277 4.69218 7.52941 5.7 7.52941ZM14.25 7.52941C15.0059 7.52941 15.7308 7.23193 16.2653 6.70242C16.7997 6.17291 17.1 5.45473 17.1 4.70588C17.1 3.95704 16.7997 3.23886 16.2653 2.70935C15.7308 2.17983 15.0059 1.88235 14.25 1.88235C13.4941 1.88235 12.7692 2.17983 12.2347 2.70935C11.7003 3.23886 11.4 3.95704 11.4 4.70588C11.4 5.45473 11.7003 6.17291 12.2347 6.70242C12.7692 7.23193 13.4941 7.52941 14.25 7.52941ZM2.1375 9.41176C1.5706 9.41176 1.02692 9.63487 0.626059 10.032C0.2252 10.4291 0 10.9678 0 11.5294V11.7647C0 11.7647 0 16 5.7 16C11.4 16 11.4 11.7647 11.4 11.7647V11.5294C11.4 10.9678 11.1748 10.4291 10.7739 10.032C10.3731 9.63487 9.8294 9.41176 9.2625 9.41176H2.1375ZM14.25 14.5882C13.1375 14.5882 12.2854 14.4179 11.6327 14.1572C12.0127 13.5221 12.2511 12.8139 12.3319 12.08C12.3412 11.9908 12.3472 11.9014 12.35 11.8118V11.5294C12.3512 10.7409 12.0441 9.98262 11.4931 9.41365L11.59 9.41176H16.91C17.4643 9.41176 17.9959 9.62992 18.3879 10.0182C18.7798 10.4065 19 10.9332 19 11.4824C19 11.4824 19 14.5882 14.25 14.5882Z"
      fill={color}
    />
  </svg>
);

export const BuildingIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8 2.18182V14H2.2V2.18182H11.8ZM4.6252 5.72727H5.8252V4.54545H4.6252V5.72727ZM8.2 5.72727H9.4V4.54545H8.2V5.72727ZM4.6252 9.27273H5.8252V8.09091H4.6252V9.27273ZM5.8252 14H8.2252V11.6364H5.8252V14ZM8.2 9.27273H9.4V8.09091H8.2V9.27273ZM1 2.18182H13V1H1V2.18182Z"
      stroke={color}
      stroke-width="2"
    />
  </svg>
);

export const AdminIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 20C11.6167 20 10.4377 19.5123 9.463 18.537C8.48833 17.5617 8.00067 16.3827 8 15C7.99933 13.6173 8.487 12.4383 9.463 11.463C10.439 10.4877 11.618 10 13 10C14.382 10 15.5613 10.4877 16.538 11.463C17.5147 12.4383 18.002 13.6173 18 15C17.998 16.3827 17.5103 17.562 16.537 18.538C15.5637 19.514 14.3847 20.0013 13 20ZM8 20C5.68333 19.4167 3.77067 18.0873 2.262 16.012C0.753334 13.9367 -0.000666225 11.6327 4.41696e-07 9.1V3L8 0L16 3V8.675C15.5667 8.45833 15.079 8.29167 14.537 8.175C13.995 8.05833 13.4827 8 13 8C11.0667 8 9.41667 8.68333 8.05 10.05C6.68333 11.4167 6 13.0667 6 15C6 16.0333 6.196 16.9667 6.588 17.8C6.98 18.6333 7.47567 19.3583 8.075 19.975C8.05833 19.975 8.046 19.9793 8.038 19.988C8.03 19.9967 8.01733 20.0007 8 20ZM13 15C13.4167 15 13.771 14.8543 14.063 14.563C14.355 14.2717 14.5007 13.9173 14.5 13.5C14.4993 13.0827 14.3537 12.7287 14.063 12.438C13.7723 12.1473 13.418 12.0013 13 12C12.582 11.9987 12.228 12.1447 11.938 12.438C11.648 12.7313 11.502 13.0853 11.5 13.5C11.498 13.9147 11.644 14.269 11.938 14.563C12.232 14.857 12.586 15.0027 13 15ZM13 18C13.5167 18 13.9917 17.879 14.425 17.637C14.8583 17.395 15.2083 17.0743 15.475 16.675C15.1083 16.4583 14.7167 16.2917 14.3 16.175C13.8833 16.0583 13.45 16 13 16C12.55 16 12.1167 16.0583 11.7 16.175C11.2833 16.2917 10.8917 16.4583 10.525 16.675C10.7917 17.075 11.1417 17.396 11.575 17.638C12.0083 17.88 12.4833 18.0007 13 18Z"
      fill={color}
    />
  </svg>
);

export const ProfilIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C9.06087 0 10.0783 0.421427 10.8284 1.17157C11.5786 1.92172 12 2.93913 12 4C12 5.06087 11.5786 6.07828 10.8284 6.82843C10.0783 7.57857 9.06087 8 8 8C6.93913 8 5.92172 7.57857 5.17157 6.82843C4.42143 6.07828 4 5.06087 4 4C4 2.93913 4.42143 1.92172 5.17157 1.17157C5.92172 0.421427 6.93913 0 8 0ZM8 16C8 16 16 16 16 14C16 11.6 12.1 9 8 9C3.9 9 0 11.6 0 14C0 16 8 16 8 16Z"
      fill={color}
    />
  </svg>
);

export const BellIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 17V18H0V17L2 15V9C2 5.9 4.03 3.17 7 2.29V2C7 1.46957 7.21071 0.960859 7.58579 0.585786C7.96086 0.210714 8.46957 0 9 0C9.53043 0 10.0391 0.210714 10.4142 0.585786C10.7893 0.960859 11 1.46957 11 2V2.29C13.97 3.17 16 5.9 16 9V15L18 17ZM11 19C11 19.5304 10.7893 20.0391 10.4142 20.4142C10.0391 20.7893 9.53043 21 9 21C8.46957 21 7.96086 20.7893 7.58579 20.4142C7.21071 20.0391 7 19.5304 7 19"
      fill={color}
    />
  </svg>
);

export const VisibilityOffIcon = ({
  size = 25,
  color = "gray",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 4C13.76 4 16 6.24 16 9C16 9.65 15.87 10.26 15.64 10.83L18.56 13.75C20.07 12.49 21.26 10.86 21.99 9C20.26 4.61 15.99 1.5 10.99 1.5C9.59 1.5 8.25 1.75 7.01 2.2L9.17 4.36C9.74 4.13 10.35 4 11 4ZM1 1.27L3.28 3.55L3.74 4.01C2.06842 5.30786 0.776644 7.03138 0 9C1.73 13.39 6 16.5 11 16.5C12.55 16.5 14.03 16.2 15.38 15.66L15.8 16.08L18.73 19L20 17.73L2.27 0L1 1.27ZM6.53 6.8L8.08 8.35C8.03 8.56 8 8.78 8 9C8 10.66 9.34 12 11 12C11.22 12 11.44 11.97 11.65 11.92L13.2 13.47C12.53 13.8 11.79 14 11 14C8.24 14 6 11.76 6 9C6 8.21 6.2 7.47 6.53 6.8ZM10.84 6.02L13.99 9.17L14.01 9.01C14.01 7.35 12.67 6.01 11.01 6.01L10.84 6.02Z"
      fill={color}
    />
  </svg>
);

export const VisibilityIcon = ({
  size = 25,
  color = "gray",
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 12C12.25 12 13.3127 11.5627 14.188 10.688C15.0633 9.81333 15.5007 8.75067 15.5 7.5C15.4993 6.24933 15.062 5.187 14.188 4.313C13.314 3.439 12.2513 3.00133 11 3C9.74867 2.99867 8.68633 3.43633 7.813 4.313C6.93967 5.18967 6.502 6.252 6.5 7.5C6.498 8.748 6.93567 9.81067 7.813 10.688C8.69033 11.5653 9.75267 12.0027 11 12ZM11 10.2C10.25 10.2 9.61267 9.93733 9.088 9.412C8.56333 8.88667 8.30067 8.24933 8.3 7.5C8.29933 6.75067 8.562 6.11333 9.088 5.588C9.614 5.06267 10.2513 4.8 11 4.8C11.7487 4.8 12.3863 5.06267 12.913 5.588C13.4397 6.11333 13.702 6.75067 13.7 7.5C13.698 8.24933 13.4357 8.887 12.913 9.413C12.3903 9.939 11.7527 10.2013 11 10.2ZM11 15C8.56667 15 6.35 14.321 4.35 12.963C2.35 11.605 0.9 9.784 0 7.5C0.9 5.21667 2.35 3.396 4.35 2.038C6.35 0.680001 8.56667 0.000667157 11 4.90196e-07C13.4333 -0.000666176 15.65 0.678667 17.65 2.038C19.65 3.39733 21.1 5.218 22 7.5C21.1 9.78333 19.65 11.6043 17.65 12.963C15.65 14.3217 13.4333 15.0007 11 15Z"
      fill="black"
    />
  </svg>
);

export const ElectricCarPlugCC = ({
  color = "#313131",
  size = 15,
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.25 4.88889C42.5 8.55556 45 13.6889 45 19.5556C45 30.3111 36 39.1111 25 39.1111C14 39.1111 5 30.3111 5 19.5556C5 13.6889 7.75 8.55556 11.75 4.88889H38.25ZM40 0H10L8.5 1.22222C3 5.86667 0 12.4667 0 19.5556C0 33 11.25 44 25 44C38.75 44 50 33 50 19.5556C50 12.4667 47 5.86667 41.5 1.22222L40 0ZM27.5 11C27.5 12.9556 29.25 14.6667 31.25 14.6667C33.25 14.6667 35 12.9556 35 11C35 9.04444 33.25 7.33333 31.25 7.33333C29.25 7.33333 27.5 9.04444 27.5 11ZM15 11C15 12.9556 16.75 14.6667 18.75 14.6667C20.75 14.6667 22.5 12.9556 22.5 11C22.5 9.04444 20.75 7.33333 18.75 7.33333C16.75 7.33333 15 9.04444 15 11ZM12.5 24.4444C15.25 24.4444 17.5 22.2444 17.5 19.5556C17.5 16.8667 15.25 14.6667 12.5 14.6667C9.75 14.6667 7.5 16.8667 7.5 19.5556C7.5 22.2444 9.75 24.4444 12.5 24.4444ZM23.75 29.3333C23.75 26.6444 21.5 24.4444 18.75 24.4444C16 24.4444 13.75 26.6444 13.75 29.3333C13.75 32.0222 16 34.2222 18.75 34.2222C21.5 34.2222 23.75 32.0222 23.75 29.3333ZM25 24.4444C27.75 24.4444 30 22.2444 30 19.5556C30 16.8667 27.75 14.6667 25 14.6667C22.25 14.6667 20 16.8667 20 19.5556C20 22.2444 22.25 24.4444 25 24.4444ZM36.25 29.3333C36.25 26.6444 34 24.4444 31.25 24.4444C28.5 24.4444 26.25 26.6444 26.25 29.3333C26.25 32.0222 28.5 34.2222 31.25 34.2222C34 34.2222 36.25 32.0222 36.25 29.3333ZM42.5 19.5556C42.5 16.8667 40.25 14.6667 37.5 14.6667C34.75 14.6667 32.5 16.8667 32.5 19.5556C32.5 22.2444 34.75 24.4444 37.5 24.4444C40.25 24.4444 42.5 22.2444 42.5 19.5556Z"
        fill={color}
      />
    </svg>
  );
};

export const SearchIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.146 12.3707 1.888 11.112C0.63 9.85333 0.000667196 8.316 5.29101e-07 6.5C-0.000666138 4.684 0.628667 3.14667 1.888 1.888C3.14733 0.629333 4.68467 0 6.5 0C8.31533 0 9.853 0.629333 11.113 1.888C12.373 3.14667 13.002 4.684 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.81267 10.5627 9.688 9.688C10.5633 8.81333 11.0007 7.75067 11 6.5C10.9993 5.24933 10.562 4.187 9.688 3.313C8.814 2.439 7.75133 2.00133 6.5 2C5.24867 1.99867 4.18633 2.43633 3.313 3.313C2.43967 4.18967 2.002 5.252 2 6.5C1.998 7.748 2.43567 8.81067 3.313 9.688C4.19033 10.5653 5.25267 11.0027 6.5 11Z"
      fill={color}
    />
  </svg>
);

export const TrashIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 1H10.5L9.5 0H4.5L3.5 1H0V3H14M1 16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H1V16Z"
      fill={color}
    />
  </svg>
);

export const EditSheetIcon = ({ color = "#313131", size = 15 }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7653 0.852061C11.9279 0.852061 13.0045 1.21987 13.8845 1.84785L5.69035 10.0411C5.60467 10.1239 5.53633 10.2229 5.48931 10.3323C5.44229 10.4418 5.41755 10.5595 5.41651 10.6786C5.41548 10.7977 5.43817 10.9159 5.48328 11.0261C5.52839 11.1364 5.595 11.2365 5.67923 11.3208C5.76347 11.405 5.86363 11.4716 5.97388 11.5167C6.08413 11.5618 6.20226 11.5845 6.32138 11.5835C6.4405 11.5825 6.55822 11.5577 6.66767 11.5107C6.77712 11.4637 6.87611 11.3953 6.95886 11.3096L15.153 3.11546C15.8005 4.02668 16.1482 5.11688 16.1479 6.23471V15.2058C16.1479 15.6816 15.9589 16.138 15.6224 16.4745C15.2859 16.811 14.8296 17 14.3537 17H1.79422C1.31836 17 0.861994 16.811 0.525513 16.4745C0.189033 16.138 0 15.6816 0 15.2058V2.64628C0 2.17042 0.189033 1.71405 0.525513 1.37757C0.861994 1.04109 1.31836 0.852061 1.79422 0.852061H10.7653ZM16.7373 0.262661C16.9055 0.430893 17 0.659035 17 0.896916C17 1.1348 16.9055 1.36294 16.7373 1.53117L15.1521 3.11546C14.8032 2.62465 14.3745 2.19585 13.8836 1.84695L15.4679 0.262661C15.6362 0.0944792 15.8643 0 16.1022 0C16.3401 0 16.5691 0.0944792 16.7373 0.262661Z"
      fill={color}
    />
  </svg>
);

export const ProhibitedIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0ZM10 2C8.1 2 6.4 2.6 5.1 3.7L16.3 14.9C17.3 13.5 18 11.8 18 10C18 5.6 14.4 2 10 2ZM14.9 16.3L3.7 5.1C2.6 6.4 2 8.1 2 10C2 14.4 5.6 18 10 18C11.9 18 13.6 17.4 14.9 16.3Z"
      fill={color}
    />
  </svg>
);

export const DownloadIcon = ({ size = 30, color = "black" }: IconProps) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 14L6 10H8V6H12V10H14L10 14ZM4 17H16C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15H4C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17Z"
      fill={color}
    />
  </svg>
);

export const PdfIcon = ({ size = 30, color = "#DC3545" }: IconProps) => (
  <svg width={size}  viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.05 0.0360107L13.832 2.93601V13.964H3.43951V14H13.8675V2.97251L11.05 0.0360107Z" fill="#909090"/>
  <path d="M11.0155 0H3.40399V13.964H13.832V2.9365L11.0155 0Z" fill="#F4F4F4"/>
  <path d="M3.32751 0.75H0.132507V4.1635H10.1825V0.75H3.32751Z" fill="#7A7B7C"/>
  <path d="M10.236 4.10551H0.19751V0.689514H10.236V4.10551Z" fill="#DD2025"/>
  <path d="M3.526 1.26702H2.8725V3.66702H3.3865V2.85752L3.5 2.86402C3.61032 2.8625 3.71963 2.84273 3.8235 2.80552C3.91481 2.77452 3.99873 2.72498 4.07 2.66002C4.14308 2.59874 4.2005 2.52092 4.2375 2.43302C4.28812 2.28738 4.30604 2.13237 4.29 1.97902C4.28715 1.86945 4.26793 1.76091 4.233 1.65702C4.20151 1.58193 4.1547 1.51423 4.09555 1.45827C4.0364 1.4023 3.96622 1.3593 3.8895 1.33202C3.82336 1.30752 3.75481 1.29009 3.685 1.28002C3.63226 1.27143 3.57893 1.26709 3.5255 1.26702M3.431 2.41402H3.3865V1.67402H3.483C3.52559 1.67095 3.56832 1.67749 3.60805 1.69315C3.64777 1.70882 3.68347 1.73321 3.7125 1.76452C3.77266 1.84503 3.80479 1.94302 3.804 2.04352C3.804 2.16652 3.804 2.27802 3.693 2.35652C3.61305 2.40056 3.52201 2.42086 3.431 2.41402ZM5.2665 1.26052C5.211 1.26052 5.157 1.26452 5.119 1.26602L5 1.26902H4.61V3.66902H5.069C5.24439 3.67353 5.41898 3.64381 5.583 3.58152C5.71506 3.52937 5.83195 3.44497 5.923 3.33602C6.01222 3.2266 6.07593 3.09866 6.1095 2.96152C6.14893 2.80648 6.16809 2.64699 6.1665 2.48702C6.17629 2.2981 6.16166 2.1087 6.123 1.92352C6.08598 1.78737 6.01747 1.66182 5.923 1.55702C5.8489 1.47228 5.75774 1.40412 5.6555 1.35702C5.56791 1.31642 5.47574 1.28654 5.381 1.26802C5.34332 1.26184 5.30517 1.259 5.267 1.25952M5.176 3.22802H5.126V1.69602H5.1325C5.23558 1.6841 5.33989 1.7027 5.4325 1.74952C5.50033 1.80368 5.5556 1.87192 5.5945 1.94952C5.63648 2.03119 5.66067 2.12082 5.6655 2.21252C5.67 2.32252 5.6655 2.41252 5.6655 2.48702C5.66735 2.57284 5.66183 2.65865 5.649 2.74352C5.63327 2.83055 5.60479 2.91479 5.5645 2.99352C5.51897 3.06694 5.45679 3.12861 5.383 3.17352C5.32135 3.21352 5.24827 3.23215 5.175 3.22652M7.715 1.26902H6.5V3.66902H7.014V2.71702H7.664V2.27102H7.014V1.71502H7.714V1.26902" fill="#464648"/>
  <path d="M9.8905 9.1275C9.8905 9.1275 11.4845 8.83851 11.4845 9.38301C11.4845 9.92751 10.497 9.706 9.8905 9.1275ZM8.712 9.169C8.4587 9.22482 8.21188 9.30675 7.9755 9.41351L8.1755 8.96351C8.3755 8.51351 8.583 7.9 8.583 7.9C8.82106 8.30207 9.09878 8.67928 9.412 9.02601C9.1762 9.06113 8.94251 9.1092 8.712 9.17001V9.169ZM8.081 5.91901C8.081 5.44451 8.2345 5.31501 8.354 5.31501C8.4735 5.31501 8.608 5.37251 8.6125 5.78451C8.57351 6.19878 8.48677 6.60715 8.354 7.00151C8.17151 6.67064 8.07732 6.29835 8.0805 5.9205L8.081 5.91901ZM5.7565 11.177C5.2675 10.8845 6.782 9.98401 7.0565 9.95501C7.055 9.95551 6.2685 11.483 5.7565 11.177ZM11.95 9.44751C11.945 9.39751 11.9 8.84401 10.915 8.86751C10.5044 8.86031 10.094 8.88925 9.6885 8.95401C9.29544 8.55837 8.9571 8.11191 8.6825 7.62651C8.8554 7.12615 8.96017 6.60481 8.994 6.07651C8.9795 5.47651 8.836 5.1325 8.376 5.1375C7.916 5.1425 7.849 5.54501 7.9095 6.14401C7.96871 6.54654 8.0805 6.93956 8.242 7.313C8.242 7.313 8.0295 7.9745 7.7485 8.6325C7.4675 9.2905 7.2755 9.63551 7.2755 9.63551C6.78679 9.7944 6.32677 10.0307 5.913 10.3355C5.501 10.719 5.3335 11.0135 5.5505 11.308C5.7375 11.562 6.392 11.6195 6.977 10.853C7.28729 10.4567 7.57124 10.0405 7.827 9.60701C7.827 9.60701 8.719 9.36251 8.9965 9.29551C9.274 9.22851 9.6095 9.17551 9.6095 9.17551C9.6095 9.17551 10.424 9.995 11.2095 9.966C11.995 9.937 11.957 9.4965 11.952 9.4485" fill="#DD2025"/>
  <path d="M10.977 0.0385132V2.97501H13.7935L10.977 0.0385132Z" fill="#909090"/>
  <path d="M11.0155 0V2.9365H13.832L11.0155 0Z" fill="#F4F4F4"/>
  <path d="M3.48751 1.22851H2.83401V3.62851H3.35001V2.81951L3.46402 2.82601C3.57434 2.82449 3.68365 2.80472 3.78751 2.76751C3.87883 2.7365 3.96275 2.68697 4.03401 2.62201C4.10655 2.56056 4.16345 2.48276 4.20001 2.39501C4.25064 2.24936 4.26856 2.09436 4.25251 1.94101C4.24966 1.83143 4.23045 1.7229 4.19551 1.61901C4.16403 1.54391 4.11722 1.47622 4.05807 1.42025C3.99892 1.36429 3.92874 1.32129 3.85202 1.29401C3.78557 1.26927 3.71668 1.25167 3.64651 1.24151C3.59378 1.23292 3.54044 1.22857 3.48701 1.22851M3.39251 2.37551H3.34801V1.63551H3.44501C3.4876 1.63244 3.53034 1.63897 3.57006 1.65464C3.60979 1.6703 3.64548 1.69469 3.67451 1.72601C3.73467 1.80652 3.76681 1.90451 3.76601 2.00501C3.76601 2.12801 3.76601 2.23951 3.65501 2.31801C3.57507 2.36204 3.48403 2.38185 3.39301 2.37501M5.22801 1.22201C5.17251 1.22201 5.11851 1.22601 5.08051 1.22751L4.96301 1.23051H4.57301V3.63051H5.03201C5.20741 3.63502 5.382 3.6053 5.54601 3.54301C5.67807 3.49086 5.79496 3.40645 5.88601 3.29751C5.97524 3.18808 6.03895 3.06015 6.07252 2.92301C6.11195 2.76797 6.13111 2.60847 6.12951 2.44851C6.1393 2.25959 6.12468 2.07019 6.08601 1.88501C6.049 1.74885 5.98049 1.62331 5.88601 1.51851C5.81191 1.43376 5.72076 1.36561 5.61852 1.31851C5.53093 1.27791 5.43876 1.24802 5.34401 1.22951C5.30634 1.22333 5.26819 1.22049 5.23001 1.22101M5.13901 3.18951H5.08902V1.65751H5.09551C5.1986 1.64559 5.30291 1.66419 5.39551 1.71101C5.46335 1.76517 5.51862 1.83341 5.55751 1.91101C5.59949 1.99268 5.62369 2.08231 5.62851 2.17401C5.63301 2.28401 5.62851 2.37401 5.62851 2.44851C5.63036 2.53432 5.62484 2.62014 5.61201 2.70501C5.59628 2.79204 5.56781 2.87628 5.52751 2.95501C5.48199 3.02843 5.41981 3.09009 5.34601 3.13501C5.28437 3.17501 5.21128 3.19363 5.13801 3.18801M7.67652 1.23051H6.46151V3.63051H6.97551V2.67851H7.62551V2.23251H6.97551V1.67651H7.67551V1.23051" fill="white"/>
  </svg>
  
);

export const ExcelIcon = ({ size = 30, color = "#217346" }: IconProps) => (
<svg width={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.7905 6.67501L3.256 5.70001V12.9045C3.25593 12.9828 3.27132 13.0604 3.30129 13.1327C3.33125 13.2051 3.3752 13.2708 3.43062 13.3261C3.48604 13.3814 3.55183 13.4253 3.62422 13.4551C3.69662 13.4849 3.77419 13.5002 3.8525 13.5H13.4025C13.4809 13.5003 13.5586 13.4852 13.6311 13.4554C13.7036 13.4256 13.7695 13.3818 13.825 13.3265C13.8805 13.2711 13.9246 13.2054 13.9546 13.1329C13.9846 13.0605 14.0001 12.9829 14 12.9045V10.25L8.7905 6.67501Z" fill="#185C37"/>
<path d="M8.7905 0.500002H3.8525C3.77419 0.499804 3.69662 0.515066 3.62422 0.54491C3.55183 0.574754 3.48604 0.618595 3.43062 0.673919C3.3752 0.729242 3.33125 0.79496 3.30129 0.867305C3.27132 0.939649 3.25593 1.0172 3.256 1.0955V3.75L8.7905 7L11.721 7.975L14 7V3.75L8.7905 0.500002Z" fill="#21A366"/>
<path d="M3.256 3.75H8.7905V7H3.256V3.75Z" fill="#107C41"/>
<path opacity="0.1" d="M7.217 3.09998H3.256V11.225H7.217C7.37483 11.2242 7.526 11.1612 7.63774 11.0498C7.74949 10.9383 7.81281 10.7873 7.814 10.6295V3.69548C7.81281 3.53764 7.74949 3.38664 7.63774 3.27517C7.526 3.16371 7.37483 3.10076 7.217 3.09998Z" fill="black"/>
<path opacity="0.2" d="M6.8915 3.42499H3.256V11.55H6.8915C7.04933 11.5492 7.2005 11.4863 7.31224 11.3748C7.42399 11.2633 7.48731 11.1123 7.4885 10.9545V4.02049C7.48731 3.86266 7.42399 3.71165 7.31224 3.60018C7.2005 3.48872 7.04933 3.42577 6.8915 3.42499Z" fill="black"/>
<path opacity="0.2" d="M6.8915 3.42499H3.256V10.9H6.8915C7.04933 10.8992 7.2005 10.8363 7.31224 10.7248C7.42399 10.6133 7.48731 10.4623 7.4885 10.3045V4.02049C7.48731 3.86266 7.42399 3.71165 7.31224 3.60018C7.2005 3.48872 7.04933 3.42577 6.8915 3.42499Z" fill="black"/>
<path opacity="0.2" d="M6.566 3.42499H3.256V10.9H6.566C6.72383 10.8992 6.875 10.8363 6.98674 10.7248C7.09849 10.6133 7.16181 10.4623 7.163 10.3045V4.02049C7.16181 3.86266 7.09849 3.71165 6.98674 3.60018C6.875 3.48872 6.72383 3.42577 6.566 3.42499Z" fill="black"/>
<path d="M0.597 3.42499H6.566C6.72412 3.42486 6.87581 3.48751 6.98776 3.59917C7.0997 3.71083 7.16274 3.86238 7.163 4.02049V9.97949C7.16274 10.1376 7.0997 10.2891 6.98776 10.4008C6.87581 10.5125 6.72412 10.5751 6.566 10.575H0.597C0.518654 10.5753 0.441026 10.56 0.368574 10.5302C0.296121 10.5004 0.23027 10.4566 0.174801 10.4013C0.119332 10.3459 0.0753357 10.2802 0.0453386 10.2078C0.0153415 10.1354 -6.60677e-05 10.0578 2.12938e-07 9.97949V4.02049C-6.60677e-05 3.94214 0.0153415 3.86455 0.0453386 3.79218C0.0753357 3.7198 0.119332 3.65406 0.174801 3.59873C0.23027 3.5434 0.296121 3.49957 0.368574 3.46975C0.441026 3.43994 0.518654 3.42473 0.597 3.42499Z" fill="url(#paint0_linear_884_38)"/>
<path d="M1.85001 8.93648L3.10551 6.99448L1.95551 5.06348H2.87901L3.50651 6.29998C3.56451 6.41698 3.60651 6.50398 3.62551 6.56198H3.63401C3.67501 6.46831 3.71834 6.37731 3.76401 6.28898L4.43501 5.06548H5.28501L4.10551 6.98548L5.31501 8.93798H4.41051L3.68551 7.58248C3.65194 7.52415 3.62334 7.4631 3.60001 7.39998H3.58801C3.56682 7.4615 3.53863 7.52038 3.50401 7.57548L2.75751 8.93648H1.85001Z" fill="white"/>
<path d="M13.403 0.500003H8.7905V3.75H14V1.0955C14.0001 1.01716 13.9847 0.939567 13.9547 0.86719C13.9247 0.794813 13.8807 0.729073 13.8252 0.673743C13.7697 0.618412 13.7039 0.574582 13.6314 0.544767C13.559 0.514952 13.4813 0.49974 13.403 0.500003Z" fill="#33C481"/>
<path d="M8.7905 7H14V10.25H8.7905V7Z" fill="#107C41"/>
<defs>
<linearGradient id="paint0_linear_884_38" x1="1.247" y1="2.95699" x2="5.916" y2="11.043" gradientUnits="userSpaceOnUse">
<stop stop-color="#18884F"/>
<stop offset="0.5" stop-color="#117E43"/>
<stop offset="1" stop-color="#0B6631"/>
</linearGradient>
</defs>
</svg>
);

export const JWayIcon = ({
  size = 30,
  color = "black",
  type,
}: IconProps & { type: IconType }) => {
  switch (type) {
    case "home":
      return <HomeIcon size={size} color={color} />;
    case "coin":
      return <CoinIcon size={size} color={color} />;
    case "electricStation":
      return <ElectricStationIcon size={size} color={color} />;
    case "peoples":
      return <PeoplesIcon size={size} color={color} />;
    case "building":
      return <BuildingIcon size={size} color={color} />;
    case "profil":
      return <ProfilIcon size={size} color={color} />;
    case "bell":
      return <BellIcon size={size} color={color} />;
    case "link-crooked":
      return <LinkCrookedIcon size={size} color={color} />;
    case "copy":
      return <CopyIon size={size} color={color} />;
    case "visibility-off":
      return <VisibilityOffIcon size={size} color={color} />;
    case "admin":
      return <AdminIcon size={size} color={color} />;
    case "visibility":
      return <VisibilityIcon size={size} color={color} />;
    case "thunder":
      return <ThunderIcon size={size} color={color} />;
    case "plus-in-cercle":
      return <PlusInCercleIcon size={size} color={color} />;
    case "electric-car-plug":
      return <ElectricCarPlugCC size={size} color={color} />;
    case "ship":
      return <ShipIcon size={size} color={color} />;
    case "search":
      return <SearchIcon size={size} color={color} />;
    case "trash":
      return <TrashIcon size={size} color={color} />;
    case "edit-sheet":
      return <EditSheetIcon size={size} color={color} />;
    case "check-valid":
      return <CheckValidationIcon size={size} color={color} />;
    case "prohibited":
      return <ProhibitedIcon size={size} color={color} />;
    case "cross":
      return <CrossIcon size={size} color={color} />;
    case "download":
      return <DownloadIcon size={size} color={color} />;
    case "pdf":
      return <PdfIcon size={size} color={color} />;
    case "excel":
      return <ExcelIcon size={size} color={color} />;
    case "stop-square":
      return <StopSquareIcon size={size} color={color} />;
    default:
      return <HomeIcon size={size} color={color} />;
  }
};
